import { IOption } from '@/components/ui/shared/DropdownSelect/DropdownSelect';

export const DEFAULT_PAGE_SIZE = 16;
export const DEFAULT_SEARCH_GROUP = 'all';

export const searchGroups: Array<IOption> = [
  { id: 'event_session', value: 'Sessions' },
  { id: 'lecture', value: 'Lectures' },
  { id: 'speakers', value: 'Authors' },
];
